import React from 'react';

import { useDiagnosticVolumeLevel } from '../../../../../../hooks/use-diagnostic-volume-level';
import { useOutputAudioHandlerContext } from '../../../../../../hooks/use-output-audio-handler';
import { VolumeMeter } from '../../../../volume-meter';

export const OutputDeviceLevel = () => {
    const { audioHandlerRef } = useOutputAudioHandlerContext();

    const volumeLvl = useDiagnosticVolumeLevel(audioHandlerRef);
    return <VolumeMeter volume={volumeLvl} length={8} />;
};
